import { EntityInput, isURLAbsolute, LinkProps } from "helpers/url";
import { isCheckCategoryVersion } from "helpers/category";
import { brandHref } from "./brand";
import { UrlObject } from "url";

const checkBrand = (entity: EntityInput) => {
  const isBrand = entity?.url.match(/brand/);

  if (!isBrand) return "";

  return brandHref();
};

export function suggestionHref(
  entity: EntityInput,
  region?: string,
  origin?: string
): LinkProps["href"] {
  /* CategorySuggestion type not contain alias field, todo: refactor type */
  if (isURLAbsolute(entity.url)) {
    return entity.url;
  }

  const brand = checkBrand(entity);

  if (brand) return brand;

  let obj: Partial<UrlObject> = {};
  if (isCheckCategoryVersion(entity.url, 1)) {
    obj = {
      pathname: "/category/[category]",
      query: {
        category: entity.url.replace(/\//g, "").replace("c_", ""),
      },
    };

    if (region) {
      obj.query["region"] = region;
    }
  } else {
    if (origin) return origin + entity.url;

    obj = {
      pathname: entity.url,
    };
  }
  return obj;
}

export function suggestionAs(
  entity: EntityInput,
  region?: string,
  origin?: string
): LinkProps["as"] {
  if (isURLAbsolute(entity.url)) {
    return entity.url;
  }

  const brand = checkBrand(entity);

  if (brand) return entity.url;

  const regionSegment = region ? `r_${region}/` : "";
  const url = `${entity.url}/${regionSegment}`.replace(/\/{2,}/g, "/");

  return origin ? origin + url : url;
}
